import { qsAll } from "../utils/dom.js";
import { setControlValidationState } from "../utils/validation-utils.js";



export function update(discountCode = '', hasDiscount = false) {
    // if booking has a discount and it was added explicitly instead of automatically by the back-end, we don't want a tag to be added
    // likewise, we want to reset the container if there are no discounts in session, incase a stale tag remains
    if (discountCode !== '' && hasDiscount) {
        // TODO: maybe refactor addDiscountTagToContainers to use renderDiscountCode internally - this way of doing it makes less sense now
        addDiscountTagToContainers(renderDiscountCode(discountCode));        
    } else {
        resetDiscountTagContainers();
    }
}

/**
 * Returns raw mark-up for a discount code tag 
 * 
 * @param {*} event 
 * @returns {void}
 */
export const renderDiscountCode = (discountString = "") => {
    if (discountString == "") {
        console.warn("Error: No discount string provided");
        return;
    }

    return (
        `<div class="align-items-center atb-discount-tag fw-semibold mb-1 me-1" data-discount-code="${discountString}" style="display: inline-flex">
            <i class="fa-solid fa-tag flip-x me-1"></i>
            <span class="text-uppercase me-1">${discountString}</span>
            <button class="p-0 close-btn" data-input="remove_discount_code" data-value="">
                <i class="fa-close fa-solid"></i>
            </button>
        </div>`
    );
}


/**
 * Used in "add-discount-code.tpl" to remove discount coupons mark-up from the checkout 
 * 
 * @param {*} event
 * @returns {void}
 */
export const removeDiscountCode = (event) => {
    if (event.target === null)
        return;

    const discountCode = event.currentTarget.parentNode.dataset.discountCode;
    removeDiscountFromBooking(discountCode);
}

export const validateDiscountInput = (event) => {
    const input = event.target;
    const container = input.closest('.atb-discount-input-field');
    const invalidFeedback = container.querySelector('.invalid-feedback');
    const validFeedback = container.querySelector('.valid-feedback');

    const value = input.value.trim();

    // look in the tags container to see if a tag with the same discount code already exists
    // NOTE: compare against the trimmed, case-insensitive value - the rendered tag uses whatever the
    // back-end returned, and mobile keyboards will happily hand us "Save10" for "SAVE10"
    const existingTag = [...document.querySelectorAll('.atb-discount-tag[data-discount-code]')].find(
        tag => (tag.dataset.discountCode || '').trim().toLowerCase() === value.toLowerCase()
    ) ?? null;

    if (existingTag != null) {
        console.warn("Discount code already applied");
        invalidFeedback.textContent = "This discount code has already been applied to your booking*";

        input.classList.add('is-invalid');
        input.classList.remove('is-valid');

        invalidFeedback.classList.remove('d-none');
        validFeedback.classList.add('d-none');
        setControlValidationState(input, invalidFeedback, false);
        return false;
    }


    if (value == "" ||
        value.length < parseIntb10(input.getAttribute('minlength')) ||
        existingTag != null
    ) {
        input.classList.add('is-invalid');
        input.classList.remove('is-valid');

        invalidFeedback.textContent = "Discount code not recognised*";

        // show the validation message
        invalidFeedback.classList.remove('d-none');
        validFeedback.classList.add('d-none');
        setControlValidationState(input, invalidFeedback, false);
        return false;
    } else {
        input.classList.remove('is-invalid');
        input.classList.remove('is-valid');

        // hide the validation message
        invalidFeedback.classList.add('d-none');
        validFeedback.classList.add('d-none');
        setControlValidationState(input, invalidFeedback, true);
    }

    return true;
}

export function addDiscountTagToContainers (discountCodeHTML) {
    const discountTagContainers = qsAll('.atb-discount-code-container');
    
    if (discountTagContainers.length < 1) {
        console.warn("No discount tag containers found");
        return;
    }

    discountTagContainers.forEach(container => {
        container.innerHTML = discountCodeHTML;
    });
}



// export const addDiscountTagToContainers = (discountCodeHTML) => {
//     const discountTagContainers = qsAll('.atb-discount-code-container');

//     if (discountTagContainers.length < 1) {
//         console.warn("No discount tag containers found");
//         return;
//     }

//     discountTagContainers.forEach(container => {
//         container.insertAdjacentHTML('beforeend', discountCodeHTML);
//     });
// }

export const removeDiscountTagFromContainers = (discountCode = "") => 
    qsAll('.atb-discount-tag').forEach(tagElement => {
        if (discountCode === tagElement.getAttribute('data-discount-code')) {
            tagElement.remove();
        }
    });

export const resetDiscountTagContainers = () => 
    qsAll('.atb-discount-tag').forEach(tagElement => {
        tagElement.remove();        
    });
